import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Phone } from 'lucide-react';
import { FloatingParticles } from './Decorative';
import { useLanguage } from '../i18n/LanguageContext';
export function FinalCTA() {
  const {
    t,
    lang
  } = useLanguage();
  const msg = lang === 'es' ? '¿Cuándo es el próximo taller de constelaciones?' : 'Quan és el proper taller de constel·lacions?';
  const waLink = `https://wa.me/34671636887?text=${encodeURIComponent(msg)}`;
  return <section className="py-20 sm:py-32 md:py-40 px-4 sm:px-6 bg-forest text-cream relative overflow-hidden" data-id="element-231">
      <FloatingParticles count={50} color="bg-gold-light" data-id="element-232" />
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-forest-light/30 via-forest to-forest opacity-80 z-0" data-id="element-233"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="bg-forest-dark/80 backdrop-blur-md p-6 sm:p-10 md:p-16 rounded-[1.5rem] sm:rounded-[3rem] border border-gold/20 shadow-2xl" data-id="element-235">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif text-gold-light mb-8 sm:mb-12 italic leading-snug" data-id="element-236">
            {t('final.title')}
          </h3>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-10" data-id="element-237">
            <a href={waLink} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-3 px-10 py-5 bg-[#25D366] text-white text-lg font-medium rounded-full hover:bg-[#20BD5A] hover:scale-105 transition-all duration-300 shadow-lg" data-id="element-238">
              <MessageCircle className="w-6 h-6" data-id="element-239" />
              {t('final.btn_wa')}
            </a>

            <a href="tel:671636887" className="w-full sm:w-auto flex items-center justify-center gap-3 px-10 py-5 bg-gold text-forest-dark text-lg font-medium rounded-full hover:bg-gold-light hover:scale-105 transition-all duration-300 shadow-lg" data-id="element-240">
              <Phone className="w-6 h-6" data-id="element-241" />
              {t('final.btn_phone')}
            </a>
          </div>

          <a href="#contacto" className="text-lg text-cream/80 hover:text-gold transition-colors font-medium" data-id="element-242">
            {t('final.link')}
          </a>
        </motion.div>
      </div>
    </section>;
}